<template>
    <v-list
        nav
        dark
        dense>
        <template v-if="user.is_super">
            <v-list-item
                v-if="$route.path.includes('/superadmin')"
                class="v-list-item--active success"
                :to="{name: 'home'}"
                link
                :input-value="true"
                :value="true">
                <v-list-item-icon>
                    <v-icon>mdi-chevron-double-left</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>
                        PARTNER AREA
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                v-else
                class="v-list-item--active warning"
                :to="{name: 'superadmin-home'}"
                link
                :input-value="true"
                :value="true">
                <v-list-item-icon>
                    <v-icon>mdi-chevron-double-right</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>
                        SUPER ADMIN AREA
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>

        <v-list-item
            :to="{name: 'profile'}"
            link>
            <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>
                    {{ user.name }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

<!--        <v-list-item link @click="toggleTheme()">
            <v-list-item-icon>
                <v-icon>mdi-toggle-switch</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>
                    Toggle Theme
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>-->

        <v-list-item link @click="logout">
            <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>
                    Log Out
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
    },

    methods: {
        ...mapActions({
            logoutAction: 'auth/logout',
        }),

        logout() {
            this.logoutAction().then(() => {
                this.$router.replace({name: 'login'});
            });
        },

        toggleTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

            localStorage.setItem("darkTheme", this.$vuetify.theme.dark.toString());
        }
    }
};
</script>
